<p-dialog
  [header]="header()"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '760px', maxWidth: '92vw' }"
  appendTo="body"
>
  <div class="flex flex-col gap-3 pt-1">
    <!-- The frame holds the ref's own aspect ratio from the first paint, so the
         16:9-in-a-9:16-project case is visible before the render even lands. -->
    <div class="preview-frame" [style.aspect-ratio]="frameAspect()">
      @switch (status()) {
        @case ('done') {
          <img class="preview-image" [src]="dataUrl()" [alt]="header()" />
        }
        @case ('error') {
          <div class="preview-message preview-message--error">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage() }}</span>
          </div>
        }
        @default {
          <div class="preview-message">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Rendering this image on its own canvas…</span>
          </div>
        }
      }
    </div>

    @if (sizeLabel(); as size) {
      <p class="text-[0.7rem] text-wb-muted m-0 leading-snug">
        Rendered at <strong>{{ size }}</strong> — the size on this image's reference in
        <code>project.json</code>, not the project's. Current argument and variable values
        are applied, so this is what a viewer would get.
      </p>
    }
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      @if (status() !== 'rendering') {
        <p-button label="Re-render" icon="pi pi-refresh" severity="secondary" (click)="rerender()" />
      }
      @if (status() === 'done') {
        <p-button label="Download" icon="pi pi-download" severity="secondary" (click)="download()" />
      }
      <p-button label="Close" (click)="close()" />
    </div>
  </ng-template>
</p-dialog>

<!-- Where the detached <webout-player> lives while it renders. Outside the
     dialog on purpose: p-dialog creates its content lazily and tears it down on
     close, and the player must stay connected for as long as the render runs —
     including the moment the operator closes the dialog mid-render, when this
     component still has to remove the element itself. -->
<div #stage class="preview-stage" aria-hidden="true"></div>
